import { makeStyles } from '@material-ui/styles';

export const useReturnsStyles = makeStyles((theme) => ({
  container: {
    marginTop: 44,
    height: 'auto',
  },
  grid: {
    border: (props) =>
      props.modifiable
        ? `1px solid ${theme.palette.primary.main}`
        : '1px solid #BCBCBC',
    width: '100%',
    borderRadius: 10,
    marginBottom: 24,
    overflow: 'hidden',
  },
  containerGrid: {
    padding: '30px 24px',
  },
  title: {
    textAlign: 'center',
    marginBottom: '40px',
  },
  icon: {
    width: 30,
    height: 30,
  },
  mainContainer: {
    display: (props) => (props.mobile ? 'block' : 'flex'),
  },
  stepsContainer: {
    flexDirection: 'column',
  },
  stepTitle: {
    display: 'inline-block',
  },
  titleContainer: {
    textAlign: (props) => (props.mobile ? 'left' : 'center'),
  },
  text: {
    fontSize: '14px',
    textAlign: (props) => (props.mobile ? 'left' : 'center'),
    paddingRight: '5px',
    marginBottom: (props) => (props.mobile ? '20px' : null),
  },
  button: {
    width: 200,
    height: 40,
  },
  containerButton: {
    backgroundColor: '#F1F1F1',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    marginTop: 10,
    marginLeft: 0,
    marginRight: 0,
    padding: '65px',
  },
}));
